import { BookingDetailsPanel } from '../../../sites/components/panel/organisms/BookingDetailsPanel';

interface AllocationDrawerContentProps {
  allocationId: string;
  potStatus?: string;
}

export function AllocationDrawerContent({
  allocationId,
  potStatus,
}: AllocationDrawerContentProps) {
  return (
    <BookingDetailsPanel allocationId={allocationId} potStatus={potStatus} />
  );
}
